export default __webpack_public_path__ + "static/video_placeholder-74d554a5f2855a914ee3879bd04c55c3.png";